module.exports = __webpack_public_path__ + "img/game-1@2x.e9864395.png";